import React from "react";
import styled from "styled-components";

import Card from "./card";

import CloseSymbol from "../assets/svg/times.svg";

const Backdrop = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;

    /* Quick and dirty fix for horizontal scroll bar (hack?) */
    max-width: 100%;

    z-index: 9999;

    background-color: rgb(0 0 0 / 0.5);

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media only screen and (max-width: 768px) {
        align-items: stretch;
    }

    /* Temporarily hide the whole thing */
    /* display: none; */
    &:not(.shown) {
        display: none;
    }

    animation: modal-backdrop-fade 0.25s;

    @keyframes modal-backdrop-fade {
        from {
            background-color: rgb(0 0 0 / 0);
        }
    }
`;

const Container = styled(Card)`
    padding: 1rem;

    margin: 1rem;
    max-width: 100%;
    max-height: 100%;

    /* The cubic-bezier thing is for the bounce effect */
    animation: modal-container-appear 0.25s cubic-bezier(0, 2, 1, 1);

    @keyframes modal-container-appear {
        from {
            transform: scale(0.8);
            opacity: 0;
        }
    }
`;

const CloseButton = styled.button`
    /* Resets and style as link */
    background-color: transparent;
    border: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    text-decoration: underline;

    display: flex;
    align-items: center;

    font-family: inherit;
    font-size: 1em;
    font-weight: 500;
    color: var(--kpum-black);
    transition: color 0.1s;

    margin-bottom: 1rem;

    &:hover {
        color: var(--kpum-orange);
    }

    svg {
        height: 1.5em;
        width: auto;
        fill: currentColor;

        margin-right: 0.5em;
    }

    svg, span {
        display: block;
    }
`;

const ModalDialog = ({ children, show, handleClose }) => (
    <Backdrop className={show && "shown"}>
        <Container role="dialog">
            <CloseButton onClick={handleClose}>
                <CloseSymbol />
                <span>Tutup</span>
            </CloseButton>
            <div>
                {children}
            </div>
        </Container>
    </Backdrop>
);

export default ModalDialog;